import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { PleaseVerify } from '@blocket/authentication-fe'
import { setVerificationModalType } from 'reduxBits/verification/actions'

const VerificationModal = ({ onVerifyClick = () => {}, tag = '', redirectUri, cancelUri}) => {
  const { type } = useSelector((state) => state.verification.modal)
  const dispatch = useDispatch()

  return (
    <PleaseVerify
      redirectUri={redirectUri}
      cancelUri={cancelUri}
      type={type}
      open={Boolean(type)}
      onClose={() => {
        dispatch(setVerificationModalType({ type: '', redirectUri: '' }))
      }}
      label="Verification modal"
      text="För att skapa en annons behöver du verifiera din inloggade session."
      tag={tag}
      onButtonClick={onVerifyClick}
    />
  )
}

VerificationModal.propTypes = {
  tag: PropTypes.string,
  onVerifyClick: PropTypes.func,
  redirectUri: PropTypes.string,
  cancelUri: PropTypes.string,
}

export default VerificationModal
